import React, { ReactHTMLElement } from 'react'

export const Button: React.FC<ReactHTMLElement<HTMLButtonElement>["props"] & {color: string, fullWidth?: boolean}> = ({color, fullWidth, ...props}) => {
  return <button {...props as any} className={`bg-${color} py-1 px-2 rounded-sm shadow-sm hover:shadow-none mt-1 mr-2 text-gray-800 ${fullWidth ? 'w-full' : ''}`} />
}